<template>
  <div class="payment">
    <div class="header">点赞建议</div>
    <div class="main">
      <div class="nav">
        <div class="navHeader">
          <div class="sculpture">
            <img :src="headImg" alt="" class="sculpture_png" v-if="headImg" />
            <div v-else>
              <img src="../assets/images/boy.png" alt="" class="sculpture_png" v-if="sex == 0" />
              <img src="../assets/images/girl.png" alt="" class="sculpture_png" v-else />
            </div>
          </div>
          <div class="name">
            <div class="merchant">
              <span>{{ name }}</span>
              <img src="../assets/images/boys.png" alt="" class="boys_png" v-if="sex == 0" />
              <img src="../assets/images/girls.png" alt="" class="boys_png" v-else />
            </div>
            <div class="stalls">
              <div class="stall" v-if="stalls">
                <!-- <span v-for="(item,index) in stallCodeSet" :key="index"> {{ item }}<span v-if="stallCodeSet.length>1">;</span>  </span>  -->
                摊位:
                <span>{{ stalls }}</span>
              </div>
              <div class="stall" v-if="mobile">
                <img src="../assets/images/phon.png" alt="" class="phones_png" />
                <span>{{ mobile }}</span>
              </div>
            </div>
          </div>
          <div class="right">
            <img src="../assets/images/letter.png" alt="" class="right_png" />
          </div>
        </div>
      </div>
    </div>
    <div class="like">
      <div class="head">
        <div @click="likes" :class="like == 1 ? 'head_left1' : 'head_left2'">我要点赞</div>
        <div @click="complaint" :class="like == 1 ? 'head_right2' : 'head_right1'">我要建议</div>
      </div>
      <div class="all_content">
        <div class="like_content" v-if="like == 1">
          <div class="line">
            <span v-for="(item, index) in likeList" :key="index" class="contents" @click="searchStatisticsInfo(item, index)" :class="spanIndex.indexOf(index) > -1 ? 'contentsTrue' : 'contentsFalse'" size="small">{{ item.name }}</span>
          </div>
          <div class="form">
            <van-form @submit="onSubmitLike">
              <van-field v-model="likeUsername" name="姓名" label="姓名" placeholder="请输入您的姓名" :rules="[{ required: true }]" />
              <van-field v-model="likePhone" name="电话" label="电话" placeholder="请输入您的电话" :rules="[{ required: true }]" />

              <div class="submit">
                <van-button round block type="info" class="btn" native-type="submit">提交</van-button>
              </div>
            </van-form>
          </div>
        </div>
        <div class="like_content" v-else-if="like == 2">
          <div class="line">
            <span v-for="(item, index) in complaintList" :key="index" class="contents" @click="complaintInfo(item, index)" :class="complaintIndex.indexOf(index) > -1 ? 'contentsTrue' : 'contentsFalse'" size="small">{{ item.name }}</span>
          </div>
          <div class="form">
            <van-form @submit="onSubmit">
              <van-field v-model="message" name="建议" label="建议" rows="2" autosize placeholder="请提出您的建议" type="textarea" maxlength="50" show-word-limit />
              <van-field v-model="username" name="姓名" label="姓名" placeholder="请输入您的姓名" :rules="[{ required: true }]" />
              <van-field v-model="phone" name="电话" label="电话" placeholder="请输入您的电话" :rules="[{ required: true }]" />

              <div class="submit">
                <van-button round block type="info" class="btn" native-type="submit">提交</van-button>
              </div>
            </van-form>
          </div>
        </div>
      </div>
    </div>

    <div class="back" @click="back">
      <img src="../assets/images/back.png" alt="" class="back_png" />
      <span class="back_word">返回</span>
    </div>
  </div>
</template>

<script>
import { merchantLike, merchantComplaint, getMerchant } from "@/api/home"
import Vue from "vue"
import { Toast } from "vant"

Vue.use(Toast)

export default {
  data() {
    return {
      username: "",
      phone: "",
      message: "",

      likeUsername: "",
      likePhone: "",

      spanIndex: [],
      likeChoosen: null,
      complaintIndex: [],
      complaintChoosen: null,
      likeList: [{ name: "蔬菜新鲜" }, { name: "环境良好" }, { name: "服务不错" }, { name: "物美价廉" }, { name: "物美价廉" }],
      complaintList: [{ name: "服务态度差" }, { name: "缺斤短两" }, { name: "质量差" }, { name: "消费欺诈" }, { name: "菜品不新鲜" }],
      like: 1,
      name: "",
      mobile: "",
      headImg: "",
      sex: "",
      stalls: "",
      merId: "",
    }
  },
  created() {
    this.merId = this.$route.params.merId
    // this.stalls = this.$route.params.stalls
  },
  mounted() {
    this.getAll()
  },
  methods: {
    searchStatisticsInfo(item, index) {
      // 获取你点击时的索引，如果找不到这个索引会为-1
      let arrIndex = this.spanIndex.indexOf(index)
      // 如果没有这个索引，则push进去
      // 有这个索引那么删除掉（取消选中）
      // 上面:class选中颜色同理
      if (arrIndex > -1) {
        this.spanIndex.splice(arrIndex, 1)
      } else {
        this.spanIndex.push(index)
      }
      let arr = []
      this.likeList.forEach((item, index) => {
        this.spanIndex.forEach(el => {
          if (el == index) {
            arr.push(item.name)
          }
        })
      })
      this.likeChoosen = arr.join(",")
    },

    complaintInfo(item, index) {
      // 获取你点击时的索引，如果找不到这个索引会为-1
      let arrIndex = this.complaintIndex.indexOf(index)
      // 如果没有这个索引，则push进去
      // 有这个索引那么删除掉（取消选中）
      // 上面:class选中颜色同理
      if (arrIndex > -1) {
        this.complaintIndex.splice(arrIndex, 1)
      } else {
        this.complaintIndex.push(index)
      }
      let arr2 = []
      this.complaintList.forEach((item, index) => {
        this.complaintIndex.forEach(el => {
          if (el == index) {
            arr2.push(item.name)
          }
        })
      })
      this.complaintChoosen = arr2.join(",")
      // console.log( this.complaintChoosen,2)
    },
    getAll() {
      getMerchant({
        merId: this.merId,
      })
        .then(res => {
          this.name = res.data.name
          this.sex = res.data.sex
          this.mobile = res.data.mobile
          this.headImg = res.data.headImg
          this.stalls = res.data.stalls
        })
        .catch(err => {
          //  alert(err)
        })
    },

    likes() {
      this.like = 1
    },
    complaint() {
      this.like = 2
    },
    back() {
      this.$router.go(-1)
    },
    // // 点赞的提交
    // btn() {
    //     if (this.likeChoosen == null) {
    //         alert('请至少选择一项')
    //         return
    //     }
    //     merchantLike({
    //         merId: this.merId,//商户id
    //         remark: this.likeChoosen,//内容
    //         stalls: this.stalls,//摊位号
    //     }).then(res => {
    //         Toast.success(res.message);
    //     }).catch(err => {
    //         //  alert(err)
    //     })
    // },

    onSubmitLike(values) {
      if (this.likeChoosen == null) {
        alert("请至少选择一项")
        return
      }
      console.log("submit", values)
      merchantLike({
        merId: this.merId, //商户id
        stalls: this.stalls, //摊位号、
        remark: this.likeChoosen, //内容
        likePerson: this.likeUsername, //点赞人
        likePhone: this.likePhone, //点赞人电话
      })
        .then(res => {
          Toast.success(res.message)
        })
        .catch(err => {
          //  alert(err)
        })
    },

    onSubmit(values) {
      let remark = ""
      if (this.complaintChoosen != null && this.message != null) {
        remark = this.complaintChoosen + "," + this.message
      } else if (this.complaintChoosen == null) {
        remark = this.message
      } else if (this.message == null) {
        remark = this.complaintChoosen
      }
      console.log("submit", values)
      merchantComplaint({
        merId: this.merId, //商户id
        remark: remark, //内容
        stalls: this.stalls, //摊位号
        complaintPerson: this.username, //投诉人
        complaintPhone: this.phone, //投诉人电话
      })
        .then(res => {
          Toast.success(res.message)
        })
        .catch(err => {
          //  alert(err)
        })
    },
  },
}
</script>

<style lang="less" scoped>
//@import "../assets/styles/home.less";
.payment {
  .header {
    height: 0.9rem;
    line-height: 0.9rem;
    font-size: 0.32rem;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 400;
    color: #3e3e3e;
    background: #ffffff;
    opacity: 1;
  }

  .main {
    box-sizing: border-box;

    // padding:0 0.24rem;
    .nav {
      box-sizing: border-box;
      background: linear-gradient(180deg, rgba(34, 110, 217, 0.22) 0%, #ffffff 100%);
      width: 100%;
      height: 4.22rem;

      .navHeader {
        display: flex;
        justify-content: flex-start;
        box-sizing: border-box;
        padding: 0.65rem 0.36rem 0;
        position: relative;

        // margin-top:0.66rem ;
        .sculpture {
          .sculpture_png {
            width: 1.76rem;
            height: 1.76rem;
            border-radius: 50%;
            border: 0.04rem solid #ffffff;
          }
        }

        .name {
          margin-left: 0.32rem;

          .merchant {
            //height: 0.6rem;
            font-size: 0.48rem;
            font-family: PingFang SC-Bold, PingFang SC;
            font-weight: bold;
            color: #3e3e3e;
            margin-top: 0.12rem;
            text-align: left;

            //line-height:0.6rem;
            .boys_png {
              width: 0.36rem;
              height: 0.36rem;
              margin-left: 0.15rem;
            }
          }

          .stalls {
            display: flex;
            justify-content: flex-start;
            margin-top: 0.06rem;

            :nth-child(2) {
              margin-left: 0.1rem;
            }

            .stall {
              // width: 1.78rem;
              height: 0.52rem;
              line-height: 0.52rem;
              // background-image: url("@/assets/images/org.png");
              // background-size: 100% 100%;
              font-size: 0.24rem;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 400;
              color: #666666;
              margin-top: 0.15rem;
              box-sizing: border-box;
              padding: 0rem 0.2rem;
              // height: 0.48rem;
              background: #e6eaf0;
              border-radius: 0.24rem;

              .phones_png {
                width: 0.28rem;
                height: 0.28rem;
                margin-top: -0.06rem;
              }
            }
          }
        }

        .right {
          position: absolute;
          right: 0.24rem;
          top: 0.2rem;

          .right_png {
            width: 2rem;
            height: 2rem;
          }
        }
      }
    }
  }

  .like {
    box-sizing: border-box;
    padding: 0 0.34rem;
    margin-top: -0.9rem;

    .head {
      width: 100%;
      height: 0.8rem;
      line-height: 0.8rem;
      // background: #ECEEF1;
      border-radius: 0.43rem;
      opacity: 1;
      border: 0.02rem solid #eceef1;
      display: flex;
      margin: 0 auto;

      .head_left1 {
        width: 50%;
        // height: 68px;
        background: #ffffff;
        border-radius: 0.43rem 0rem 0rem 0.43rem;
        opacity: 1;
        font-size: 0.32rem;
        font-weight: 400;
        color: #3a5ef1;
      }

      .head_left2 {
        width: 50%;
        // height: 68px;
        background: #eceef1;
        border-radius: 0.43rem 0rem 0rem 0.43rem;
        opacity: 1;
        font-size: 0.32rem;
        font-weight: 400;
        color: #6e6e6e;
      }

      .head_right1 {
        width: 50%;
        // height: 68px;
        background: #ffffff;
        border-radius: 0rem 0.43rem 0.43rem 0rem;
        opacity: 1;

        font-size: 0.32rem;
        font-weight: 400;
        color: #3a5ef1;
      }

      .head_right2 {
        width: 50%;
        // height: 68px;
        background: #ffffff;
        border-radius: 0rem 0.43rem 0.43rem 0rem;
        opacity: 1;
        background: #eceef1;
        font-size: 0.32rem;
        font-weight: 400;
        color: #6e6e6e;
      }
    }

    .all_content {
      .like_content {
        .line {
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;

          .contentsFalse {
            box-sizing: border-box;
            height: 0.68rem;
            background: #ffffff;
            border-radius: 0.34rem;
            opacity: 1;
            border: 0.02rem solid #aaaaaa;
            padding: 0.1rem 0.3rem;
            margin: 0.25rem 0.35rem 0 0;
            font-size: 0.32rem;
            color: #999999;
          }

          .contentsTrue {
            box-sizing: border-box;
            height: 0.68rem;
            background: #e8ecf9;
            border-radius: 0.34rem;
            opacity: 1;
            border: 0.02rem solid #3a5ef1;
            padding: 0.1rem 0.3rem;
            margin: 0.25rem 0.35rem 0 0;
            font-size: 0.32rem;
            color: #3a5ef1;
          }
        }

        .form {
          margin: 1rem auto 0;

          .van-cell {
            background: #f5f5f5;
            margin: 0.2rem 0;
            border-radius: 0.16rem;
          }

          .submit {
            width: 100%;
            height: 1.66rem;
            background: #ffffff;
            box-shadow: 0rem 0.04rem 0.24rem 0rem #f0f0f0;
            position: fixed;
            bottom: 0;
            left: 0;

            .btn {
              width: 85%;
              height: 0.88rem;
              line-height: 0.88rem;
              background: #3a5ef1;
              border-radius: 0.57rem;
              font-size: 0.32rem;
              font-family: PingFang SC-Bold, PingFang SC;
              font-weight: 400;
              color: #ffffff;
              margin: 0.3rem auto 0;
            }
          }
        }
      }
    }
  }

  .back {
    width: 1.74rem;
    height: 0.92rem;
    line-height: 0.92rem;
    background: #ffffff;
    box-shadow: 0rem 0.12rem 0.26rem -0.02rem #dcdcdc;
    border-radius: 0.2rem;
    position: fixed;
    bottom: 1.78rem;
    left: 0.14rem;

    .back_png {
      width: 0.3rem;
      height: 0.44rem;
      vertical-align: middle;
      margin-top: -0.1rem;
    }

    .back_word {
      font-size: 0.32rem;
      font-weight: 400;
      color: #3d3d3d;
      margin-left: 0.1rem;
    }
  }
}
</style>
